import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface GarageDoorProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const GarageDoor: React.FC<GarageDoorProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [garageDoor, set_garageDoor] = useBudgetFixFlipField<number>(
        propertyGuid,
        (b) => (b.values?.['Exterior Structure']?.['Garage Door']?.[1] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Exterior Structure': { ...b.values?.['Exterior Structure'], 'Garage Door': [b.values?.['Exterior Structure']?.['Garage Door']?.[0] ?? '', v] as [string, number] } } })
    );
    const label = 'Garage Door';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(garageDoor)}
                />
            ) : (
                <MoneyBox
                    id={'garageDoor'}
                    allowNegative={false}
                    value={garageDoor}
                    onChange={(value) => set_garageDoor(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
